import mapDocument from "../utils/mapDocument";

export default async function getDocumentData(ref) {
	if (ref) {
		const doc = await ref.get();

		return doc.exists && mapDocument(doc);
	}
}
